import request from "@/utils/request";

const sqlApi = {
    batches: '/api/yasdbs/execute'
}

// 执行 sql
export function runSqlApi(param) {
    return request({
        url: sqlApi.batches,
        method: 'post',
        data: param
    })
}
